import styled from 'styled-components'
import { WHITE, GRAY_DARK, GRAY_LIGHT, RED, BLUE, RED_TRANSPARENT_BRIGHT, 
  ORANGE, ORANGE_SELECTED } from '../../../theme/colors'
import Checkbox from 'antd/lib/checkbox'
import icon from 'antd/lib/icon'
import { AVENIR_NEXT } from '../../../theme/fonts'

interface ImagePreviewProps {
  src: string
}

interface DivProps {
  selected?: boolean
  highlight?: boolean
}

export const FilesContentWrapper = styled.div`
  width: 100%;
  max-width: 1024px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  & > * {
    max-width: 100%;
  }
`

export const Container = styled.div`
  width: 100%;
  background-color: ${WHITE};
  display: flex;
  padding-right: 2px;
  min-height: 400px;
  padding: 10px 180px;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
  }
  @media (max-width: 320px) {
    width: 100%;
    padding: 0 10px;
    margin-top: -20px;
  }
`

export const DraggerContainer = styled.div`
  margin-bottom: 10px;
  width: 100%;
  transition: all .25s;
  padding: ${({ highlight }: DivProps) => highlight ? '4px' : 'unset'};
  background: ${({ highlight }: DivProps) => highlight ? RED_TRANSPARENT_BRIGHT : 'unset'};
  .ant-upload.ant-upload-drag {
    padding: 18px;
    @media (max-width: 320px) {
      padding: 10px;
    }
  }
`

export const ButtonContainer = styled.div`
  display: inline-block;
  margin-left: 8px;
`

export const AskButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 28px;
`

export const AskButton = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${GRAY_DARK};
  padding: 8px 16px;
  border-color: ${({ selected }: DivProps) => selected ? RED : GRAY_DARK };
  color: ${({ selected }: DivProps) => selected ? WHITE : GRAY_DARK };
  background: ${({ selected }: DivProps) => selected ? RED : WHITE };
  transition: all .25s;
  &:last-child {
    margin-left: 18px;
  }
  &:hover {
    cursor: pointer;
    background: ${RED};
    border-color: ${RED};
    color: ${WHITE};
  }
  strong {
    margin-right: 6px;
  }
`

export const Icon = styled(icon)`
  margin-right: 8px;
`

export const Description = styled.div`
  margin: 10px 0 30px 0;
`

export const Images = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  h2 {
    margin-bottom: 12px;
    color: #302628;
    font-size: 13px;
    font-weight: 600;
  }
  @media (max-width: 768px) {
    justify-content: center;
  }
  @media (max-width: 320px) {
    border-top: solid 2px #EBEDF0;
    padding-top: 12px;
    & > .files-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      h2 {
        margin-bottom: 0;
      }
      span {
        font-size: 12px;
        color: #8F8889;
      }
    }
  }
`

export const ImageContainer = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 768px) {
    width: 130px;
  }
`

export const Image = styled.div`
  background-size: cover;
  background-position: center;
  background-image: url('${({ src }: ImagePreviewProps) => src || ''}');
  width: 300px;
  height: 300px;
  background-color: ${GRAY_LIGHT};
  @media (max-width: 768px) {
    width: 130px;
    height: 130px;
  }
`

export const LoginMessage = styled.div`
  font-size: 16px;
  line-height: 23px;
  margin-top: 16px;
  text-align: center;
`

export const CustomButton = styled.div`
  padding: 5px;
  border: 1px solid ${GRAY_DARK};
  border-radius: 4px;
  justify-content: center;
  width: 200px;
  margin-top: 22px;
  display: inline-flex;
  cursor: pointer;
  transition: background 0.4s ease, color 0.3s ease;
  &:hover {
    background: ${GRAY_DARK}
    color: ${WHITE}
  }
`

export const LoginText = styled.div``

export const ImageText = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  font-weight: 600;
  margin-top: 6px;
  overflow: hidden;
  white-space: nowrap;
`

export const Button = styled.div`
  margin-top: 2px;
  &:hover {
    cursor: pointer;
  }
`
export const DeleteButton = styled(Button)`
  color: ${RED};
`
export const EditButton = styled.div`
  color: ${BLUE};
`

export const ActionButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`

export const CheckboxLabel = styled.div`
  margin-top: -1px;
`

export const EmptyMessage = styled.div`
  display: flex;
  justify-content: center;
  font-size: 16px;
  margin-top: 35px;
`

export const StyledCheckbox = styled(Checkbox)`
  background: ${({ highlight }: DivProps) => highlight ? RED_TRANSPARENT_BRIGHT : 'unset'};
  transition: all .25s;
  color: ${({ highlight }: DivProps) => highlight ? RED : 'unset'};
  display: flex;
  width: 100%;
  margin-top: 14px;
  font-family: ${AVENIR_NEXT};
  .ant-checkbox-inner {
    border: 1px solid #bababa;
  }
  @media (max-width: 768px) {
    display: flex;
    font-size: 13px;
  }
  @media (max-width: 320px) {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
`

export const TermsLink = styled.span`
  color: ${BLUE};
  margin-left: 4px;
  margin-right: 4px;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  @media (max-width: 320px) {
    font-size: 12px;
    color: #8F8889;
  }
`

export const RequiredMark = styled.span`
  color: ${RED};
  margin-left: 2px;
`

export const AIGeneratedImages = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-top: 24px;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.5;
  border: 1px solid ${ORANGE};
  border-radius: 10px;
  background: ${ORANGE_SELECTED};
  @media (max-width: 320px) {
    font-size: 12px;
    padding: 10px;
    border-radius: 10px;
  }
`

export const AIGeneratedImagesIcon = styled.span`
  flex-shrink: 0;
  color: ${RED};
  font-size: 18px;
  line-height: 1;
  margin-right: 8px;
  @media (max-width: 320px) {
    margin-right: 4px;
  }
`

export const TitleTerms = styled.div`
  font-weight: bold;
  margin-top: 22px;
  font-size: 16px;
  text-align: center;
`

export const TooltipContentModal = styled.div`
  margin-left: -22px;
  width: 100%;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  margin-bottom: 12px;
  max-height: 448px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .3);
  }
  .highlight {
    color: red;
    font-style: italic;
  }

  b {
    font-weight: 700;
  }
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const buttonStyle = {
  position: 'absolute',
  right: '-6px',
  top: '-6px',
  color: '#393939',
  border: '1px solid #2d2d2d',
  borderRadius: '25px',
  width: '24px',
  height: '24px',
  background: 'white',
  fontSize: '12px',
  padding: '0',
  lineHeight: 'unset'
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/Files/styledComponents.tsx